import "react-toastify/dist/ReactToastify.css";
import { ExclamationIcon, ToastStyled } from "./styles";

export default function SharedToast(props) {
  return <ToastStyled limit={2} icon={<ExclamationIcon />} />;
}
